import React from 'react';
import BoardDetail from './BoardDetail';

export default function EventDetail() {
  return <BoardDetail fixedType="event" basePath="/event" />;
}
